import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-wrap',

    tabs: 'mb-2 w-full gap-1 bg-white',
    tab: 'h-10 px-[43px] py-2 normal-case',
    tabsWrap: 'flex cursor-grab justify-between p-1',
    additionalTab:
      'heading-m hover:text-main hover:border-main min-w-44 shrink-0 grow cursor-pointer border-b border-gray-200 p-3 whitespace-nowrap text-gray-700 transition-colors',
    header: 'bg-bg-main flex cursor-pointer px-5 py-4 normal-case',
    headerIcon: 'ml-auto',
    wrapper: '',
    content: 'w-full',
    tabHeaderIcon: '',
    title: 'heading-m lg:heading-2xl mb-6 font-medium lg:mb-4 lg:font-medium'
  },
  variants: {
    color: {
      primary: 'text-black'
    },
    view: {
      tab: {
        header: 'hidden',
        wrapper: 'order-2 !max-h-max',
        tabs: 'rounded-full'
      },
      additionalTab: {
        header: 'hidden',
        tabs: 'gap-4 bg-white',
        wrapper: 'order-2 !max-h-max'
      },
      accordion: {
        base: '',
        tabs: 'bg-text-main-inversion mb-0 hidden',
        header:
          'bg-text-main-inversion heading-m-bold mt-4 mb-0 w-full items-center p-5',
        content: '[&>a]:text-brand-primary pb-5',
        wrapper:
          'bg-text-main-inversion heading-m -mt-2.5 px-3 lg:-mt-1 lg:px-5'
      },
      auto: {
        tabs: 'hidden rounded-full md:flex',
        header: 'w-full max-md:mb-1 md:hidden',
        content: 'max-md:pb-5',
        wrapper: 'md:order-2 md:!max-h-max'
      }
    },
    active: {
      true: {
        tabHeaderIcon: 'brightness-0 invert filter'
      },
      false: {}
    }
  },
  compoundVariants: [
    {
      view: 'tab',
      active: false,
      className: {
        content: 'hidden'
      }
    },
    {
      view: 'additionalTab',
      active: false,
      className: {
        content: 'hidden'
      }
    },
    {
      view: 'additionalTab',
      active: true,
      className: {
        additionalTab: 'border-main heading-m-bold text-text-main border-b-2'
      }
    },
    {
      view: 'auto',
      active: false,
      className: {
        content: 'md:hidden'
      }
    }
  ],
  defaultVariants: {
    color: 'primary'
  }
});
